import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type RiskScore } from '../../api/security';

export function RiskCenterPage() {
  const [risks, setRisks] = useState<RiskScore[]>([]);
  useEffect(() => { void securityApi.risks().then(setRisks); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Risk Center</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{risks.map((r) => (
        <div key={r.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <p className="font-medium capitalize">{r.entity_type}: {r.entity_id}</p>
          <p className="mt-2 text-2xl font-semibold">{r.score}</p>
          <p className="text-sm text-slate-500">Level: {r.level}</p>
        </div>
      ))}</div>
    </div>
  );
}
